import styled from 'styled-components'

import { IconSearch } from 'components/Icons/IconSearch'
import { IconClose } from 'components/Icons/IconClose'

const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 500px;
  height: 46px;
  padding: 0px 24px;
  border-radius: 100px;
  border: 1px solid ${p => p.theme.colors.text.primary};
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    width: calc(100% - 40px);
  }
`

const StyledInput = styled.input`
  border: none;
  outline: none;
  flex-grow: 1;
  font-size: 18px;
  background-color: transparent;
  color: ${p => p.theme.colors.text.primary};
  &::placeholder {
    color: ${p => p.theme.colors.input.placeholder};
  }
`

interface Props {
  text: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClear: () => void
}

export const SearchInput = ({ text, onChange, onClear }: Props) => {
  return (
    <SearchInputContainer>
      <StyledInput value={text} onChange={onChange} placeholder="Search..." />
      {text.length === 0 ? (
        <div style={{ display: 'flex' }}>
          <IconSearch />
        </div>
      ) : (
        <div style={{ display: 'flex', cursor: 'pointer' }} onClick={onClear}>
          <IconClose />
        </div>
      )}
    </SearchInputContainer>
  )
}
